import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { errMsg } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Field } from "../../components/admin/AdminUI";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Painel | EMAIA PERFUMES";
  }, []);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(errMsg(err, "Não foi possível entrar."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="arabesque flex min-h-screen items-center justify-center bg-[#0B0B0C] px-5">
      <form onSubmit={submit} className="fade-up w-full max-w-sm space-y-5 rounded-2xl border border-[#D4AF37]/20 bg-[#141417] p-8" data-testid="admin-login-form">
        <div className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full border border-[#D4AF37]/40"><Lock className="h-5 w-5 text-[#D4AF37]" /></div>
          <p className="gold-text font-serif text-3xl font-semibold tracking-[0.3em]">EMAIA</p>
          <p className="mt-1 text-xs uppercase tracking-[0.3em] text-[#A1A1AA]">Acesso administrativo</p>
        </div>
        <Field label="E-mail"><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" data-testid="admin-login-email-input" /></Field>
        <Field label="Senha"><Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" data-testid="admin-login-password-input" /></Field>
        {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} className="btn-gold w-full" data-testid="admin-login-submit">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />}Entrar
        </button>
      </form>
    </div>
  );
}
